import { Close } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { Chat } from './Chat';
import { useContext } from 'react';
import { Footer } from './Footer';
import { TargetNameAndDescription, targetNameAndDescriptionStyle } from '@/components/common/TargetNameAndDescription';
import { ctxMessages } from '@/contexts/MessagesCtx';

export function ChatWindow() {
  const ctx = useContext(ctxMessages);
  if (!ctx || !ctx.thread) {
    return;
  }
  function clearThread() {
    ctx?.setThread(undefined);
  }
  return (
    <div className="chat-container">
      <div className="chat-thread-header chat-panel-header">
        <TargetNameAndDescription
          targetName={ctx.thread.user.name}
          targetDescription={ctx.thread.user.description}
          styleClassName={targetNameAndDescriptionStyle(undefined, undefined)}
        />
        <span className="chat-close">
          <IconButton onClick={clearThread} color="primary">
            <Close />
          </IconButton>
        </span>
      </div>
      <div className="chat-body">
        <Chat key={ctx.thread.threadId} />
      </div>
      <div className="chat-footer">
        <Footer />
      </div>
    </div>
  );
}
